
import { Children } from "react"
import { theme } from "../../../../utils/theme/godzilla_light"
import { Box, Typography, useMediaQuery } from "@mui/material"
import { GradientCard, PageSection } from "../../components"
import { Trans, useTranslation } from "react-i18next"
import Educate1 from '../../../../assets/images/svgs/counsellingPatients/educate_01.png.svg'
import Educate2 from '../../../../assets/images/svgs/counsellingPatients/educate_02.png.svg'
import Educate3 from '../../../../assets/images/svgs/counsellingPatients/educate_03.png.svg'
import TransMsg from './transMessage'

const styles = {
    itemCardWrapper: {
        ...theme.components.shadowCard,
        p: "33px 18px 33px 18px",
        maxWidth: "343px",
        width: "100%"
    },
    itemDescription: {
        ...theme.typography.components.sectionDescription,
        fontSize: "16.45px",
        color: "#393939",
        mt: "9px",
        lineHeight: "27px"
    }
}

const CardItemComponent = (props: any) => {
    const { t } = props
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    const cardItemList = [
        {
            imageUrl: Educate1,
            description: "Describing GA and explaining the impact it may have"
        },
        {
            imageUrl: Educate2,
            description: "Reviewing the goals of management"
        },
        {
            imageUrl: Educate3,
            description: "Defining the importance of regular monitoring"
        }
    ]

    return (
        <Box mt={"38px"} display={"flex"} gap={"24px"} flexWrap={"wrap"} px={"31px"} width={"100%"}  justifyContent={"center"}>
            {Children.toArray(cardItemList.map((item) => {
                return (
                    <Box flex={isMobileX ? "none" : 1} sx={styles.itemCardWrapper} >
                        <Box sx={{ height: "145px", maxWidth: "343px" }}>
                            <img src={item.imageUrl} style={{ maxWidth: "343px" }} alt="counselling-img" />
                        </Box>
                        <Typography sx={styles.itemDescription}>
                            {item.description}
                        </Typography>
                    </Box>
                )
            }))}
            <GradientCard
                cardSx={{ width:"100%", mt: "41px", p: isMobileX ? "55px 48px 106px 31px" : "65px 240px 65px 210px", textAlign: isMobileX ? "left" : "center"}}
                content={<Trans
                    i18nKey={t(TransMsg.EDUCATE_TO_EMPOWER_NOTES)}
                    components={{ sup: <sup /> }} />}
            />
        </Box>
    )
}

const EducateToEmpower = () => {
    const { t } = useTranslation()
    return (
        <PageSection
            title={t(TransMsg.EDUCATE_TO_EMPOWER)}
            description={t(TransMsg.EDUCATE_TO_EMPOWER_DESCRIPTION)}
            sectionTitle={t(TransMsg.EDUCATE_TO_EMPOWER_SUB_TITLE)}
            descriptionSx={{ mt: "38px" }}
            subTitleSx={{ mt: "38px", fontWeight: 400 }}
            customElement={<CardItemComponent t={t} />}
        />
    )
}

export default EducateToEmpower
